import { createFileRoute } from '@tanstack/react-router';

import { SavedReportsPage } from '../features/reporting/savedReports/components/SavedReportsPage/SavedReportsPage';
import { SavedReportSource } from '../features/reporting/savedReports/model';

export const Route = createFileRoute('/reporting/saved-reports')({
  component: OwnedSavedReportsRoute,
});

function OwnedSavedReportsRoute() {
  return <SavedReportsPage source={SavedReportSource.Owned} />;
}
